import React, { useEffect, useState } from 'react';


const USE_COLOR_CHANGE_ID = '__use_color_change';

const insertStyleSheetRule = (ruleText) => {
    let style = document.getElementById(USE_COLOR_CHANGE_ID)
    if (style == null) {
        style = document.createElement('style');
        style.setAttribute('id', USE_COLOR_CHANGE_ID)
        style.appendChild(document.createTextNode(''));
        document.head.appendChild(style);
    }

    const {sheet} = style;
    sheet?.insertRule(
        ruleText,
        sheet.rules ? sheet.rules.length : sheet.cssRules.length
    );
};

const makeAnimation = (color, property) => {
    const random =
        'use-color-change' + String(Math.random()).replace(/\./g, '');
    const animation = `@keyframes ${random} { from {${property}: ${color};font-weight: 600;} to {} }`;
    insertStyleSheetRule(animation);
    return random;
};

const useColorChange = (value, options) => {
    const [val, setVal] = useState(value);
    const [animation, setAnimation] = useState('');

    const duration = options.duration || 1800;
    const property = options.property || 'color';

    useEffect(() => {
        if (value > val && options.higher) {
            setAnimation(makeAnimation(options.higher, property));
        } else if (value < val && options.lower) {
            setAnimation(makeAnimation(options.lower, property));
        }
        setVal(value);
    }, [duration, property, options.higher, options.lower, val, value]);

    if (!animation) {
        return {};
    }

    return {
        animation: `${animation} ${duration / 1000}s`
    };
};

const AnimatedCount = ({value, children, duration = 600, higherColor = TB.config('color.success-darker'), lowerColor = TB.config('color.danger'),...props}) => {
    const colorStyle = useColorChange(value, {
        higher: higherColor,
        lower: lowerColor,
        duration
    });

    return <p style={colorStyle} {...props}>
        {children}
    </p>
}

export default AnimatedCount;